import { DmsModal, DmsTabber, DmsButton, intl } from "dmsbasereact";
import { Box } from "@mui/material";
import { useEffect } from "react";
import { getBrazilianStateOptions } from "../../constants/BrazilianStates";
import { getGenderOptions } from "../../constants/GenderEnum";
import { useCreatePatientForm } from "./useCreatePatientForm";
import { TabPatientCreate } from "./TabPatientCreate";
import { TabResponsibleLegalCreate } from "./TabResponsibleLegalCreate";
import PatientPreviewModal from "./PatientPreviewModal";

export const ModalFormCreatePatient = ({ isVisible, onClose, table, initialCpf = '', initialDob = null, initialName = '' }) => {
    const { state, handlers } = useCreatePatientForm({ table, onClose, initialCpf, initialDob, initialName });
    const {
        hasPregnancyPotential,
        menstrualCycleRegular,
        hasResponsibleLegal,
        sameAddressAsPatient,
        cpfValue,
        cpfIsValid,
        selectedGenderOption,
        startDate,
        highlyEffectiveMethods,
        barrierMethods,
        selectedInfertilityReason,
        selectedInfertilityReasonName,
        dataUsageConsentAccepted,
        contactAuthorization,
        showPreviewModal,
        patientName,
        zipCode,
        city,
        state: patientState,
        address,
        addressNumber,
        phone,
        email,
        rg,
        rgIssuingAgency,
        responsibleCpfValue,
        responsibleCpfIsValid,
        responsibleBirthDate,
        responsibleName,
        responsibleZipCode,
        responsibleCity,
        responsibleState,
        responsibleAddress,
        responsibleAddressNumber,
        responsiblePhone,
        responsibleEmail,
        responsibleRg,
        responsibleRgIssuingAgency,
        isSubmitting,
        isFormValid,
        validationErrors,
        fieldErrors,
    } = state;

    const {
        setHasPregnancyPotential,
        setMenstrualCycleRegular,
        setHasResponsibleLegal,
        setSameAddressAsPatient,
        setCpfValue,
        setCpfIsValid,
        setSelectedGenderOption,
        setStartDate,
        setPatientName,
        setZipCode,
        setCity,
        setState: setPatientState,
        setAddress,
        setAddressNumber,
        setPhone,
        setEmail,
        setRg,
        setRgIssuingAgency,
        setResponsibleCpfValue,
        setResponsibleCpfIsValid,
        setResponsibleBirthDate,
        setResponsibleName,
        setResponsibleZipCode,
        setResponsibleCity,
        setResponsibleState,
        setResponsibleAddress,
        setResponsibleAddressNumber,
        setResponsiblePhone,
        setResponsibleEmail,
        setResponsibleRg,
        setResponsibleRgIssuingAgency,
        setHighlyEffectiveMethods,
        setBarrierMethods,
        setSelectedInfertilityReason,
        setSelectedInfertilityReasonName,
        setDataUsageConsentAccepted,
        setContactAuthorization,
        handleSave,
        resetStates,
        handleOpenPreview,
        handleClosePreview,
    } = handlers;


    const stateOptions = getBrazilianStateOptions();

    const genderOptions = getGenderOptions();

    useEffect(() => {
        if (isVisible) {
            resetStates();
        }
    }, [isVisible, resetStates]);


    // Build tabs array
    const tabs = [
        {
            title: intl.get("Patient").d("Patient"),
            component: (
                <TabPatientCreate
                    cpfValue={cpfValue}
                    setCpfValue={setCpfValue}
                    cpfIsValid={cpfIsValid}
                    setCpfIsValid={setCpfIsValid}
                    startDate={startDate}
                    setStartDate={setStartDate}
                    selectedGenderOption={selectedGenderOption}
                    setSelectedGenderOption={setSelectedGenderOption}
                    hasPregnancyPotential={hasPregnancyPotential}
                    setHasPregnancyPotential={setHasPregnancyPotential}
                    menstrualCycleRegular={menstrualCycleRegular}
                    setMenstrualCycleRegular={setMenstrualCycleRegular}
                    hasResponsibleLegal={hasResponsibleLegal}
                    setHasResponsibleLegal={setHasResponsibleLegal}
                    stateOptions={stateOptions}
                    genderOptions={genderOptions}
                    patientName={patientName}
                    setPatientName={setPatientName}
                    zipCode={zipCode}
                    setZipCode={setZipCode}
                    city={city}
                    setCity={setCity}
                    state={patientState}
                    setState={setPatientState}
                    address={address}
                    setAddress={setAddress}
                    addressNumber={addressNumber}
                    setAddressNumber={setAddressNumber}
                    phone={phone}
                    setPhone={setPhone}
                    email={email}
                    setEmail={setEmail}
                    rg={rg}
                    setRg={setRg}
                    rgIssuingAgency={rgIssuingAgency}
                    setRgIssuingAgency={setRgIssuingAgency}
                    highlyEffectiveMethods={highlyEffectiveMethods}
                    setHighlyEffectiveMethods={setHighlyEffectiveMethods}
                    barrierMethods={barrierMethods}
                    setBarrierMethods={setBarrierMethods}
                    selectedInfertilityReason={selectedInfertilityReason}
                    setSelectedInfertilityReason={setSelectedInfertilityReason}
                    setSelectedInfertilityReasonName={setSelectedInfertilityReasonName}
                    dataUsageConsentAccepted={dataUsageConsentAccepted}
                    setDataUsageConsentAccepted={setDataUsageConsentAccepted}
                    contactAuthorization={contactAuthorization}
                    setContactAuthorization={setContactAuthorization}
                    fieldErrors={fieldErrors}
                />
            ),
        },
    ];

    if (hasResponsibleLegal) {
        tabs.push({
            title: intl.get("ResponsibleLegal").d("Legal Guardian"),
            component: (
                <TabResponsibleLegalCreate
                    responsibleCpfValue={responsibleCpfValue}
                    setResponsibleCpfValue={setResponsibleCpfValue}
                    responsibleCpfIsValid={responsibleCpfIsValid}
                    setResponsibleCpfIsValid={setResponsibleCpfIsValid}
                    responsibleBirthDate={responsibleBirthDate}
                    setResponsibleBirthDate={setResponsibleBirthDate}
                    sameAddressAsPatient={sameAddressAsPatient}
                    setSameAddressAsPatient={setSameAddressAsPatient}
                    stateOptions={stateOptions}
                    responsibleName={responsibleName}
                    setResponsibleName={setResponsibleName}
                    responsibleZipCode={responsibleZipCode}
                    setResponsibleZipCode={setResponsibleZipCode}
                    responsibleCity={responsibleCity}
                    setResponsibleCity={setResponsibleCity}
                    responsibleState={responsibleState}
                    setResponsibleState={setResponsibleState}
                    responsibleAddress={responsibleAddress}
                    setResponsibleAddress={setResponsibleAddress}
                    responsibleAddressNumber={responsibleAddressNumber}
                    setResponsibleAddressNumber={setResponsibleAddressNumber}
                    responsiblePhone={responsiblePhone}
                    setResponsiblePhone={setResponsiblePhone}
                    responsibleEmail={responsibleEmail}
                    setResponsibleEmail={setResponsibleEmail}
                    responsibleRg={responsibleRg}
                    setResponsibleRg={setResponsibleRg}
                    responsibleRgIssuingAgency={responsibleRgIssuingAgency}
                    setResponsibleRgIssuingAgency={setResponsibleRgIssuingAgency}
                    fieldErrors={fieldErrors}
                />
            ),
        });
    }

    return (
        <>
        <DmsModal isVisible={isVisible} onClose={onClose} closeWithIconOnly>
            <DmsModal.Header
                title={intl.get("CreatePatient").d("Create Patient")}
                onClose={onClose}
            />
            <DmsModal.Body>
                <DmsTabber tabs={tabs} pageName={intl.get("CreatePatient").d("Create Patient")} />
            </DmsModal.Body>
            <DmsModal.Footer>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, width: '100%' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                        <DmsButton
                            variant="secondary"
                            text={intl.get("Cancel").d("Cancel")}
                            onClick={onClose}
                        />
                        <DmsButton
                            variant="primary"
                            text={intl.get("ReviewData").d("Review Data")}
                            onClick={handleOpenPreview}
                            disabled={!isFormValid}
                        />
                    </Box>
                </Box>
            </DmsModal.Footer>
        </DmsModal>

        <PatientPreviewModal
            isVisible={showPreviewModal}
            onClose={handleClosePreview}
            onConfirm={handleSave}
            isLoading={isSubmitting}
            patientData={{
                name: patientName,
                cpf: cpfValue,
                birthDate: startDate,
                gender: selectedGenderOption,
                rg: rg,
                rgIssuingAgency: rgIssuingAgency,
                phone: phone,
                email: email,
                zipCode: zipCode,
                city: city,
                state: patientState,
                address: address,
                addressNumber: addressNumber,
                hasPregnancyPotential: hasPregnancyPotential,
                menstrualCycleRegular: menstrualCycleRegular,
                highlyEffectiveMethods: highlyEffectiveMethods,
                barrierMethods: barrierMethods,
                infertilityReasonName: selectedInfertilityReasonName,
            }}
            responsibleLegalData={hasResponsibleLegal ? {
                name: responsibleName,
                cpf: responsibleCpfValue,
                birthDate: responsibleBirthDate,
                phone: responsiblePhone,
                email: responsibleEmail,
                zipCode: sameAddressAsPatient ? zipCode : responsibleZipCode,
                city: sameAddressAsPatient ? city : responsibleCity,
                state: sameAddressAsPatient ? patientState : responsibleState,
                address: sameAddressAsPatient ? address : responsibleAddress,
                addressNumber: sameAddressAsPatient ? addressNumber : responsibleAddressNumber,
            } : null}
        />
        </>
    )
}
